var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRibbonBronze(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 56,
    viewBox: "0 0 38 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ribbon bronze 1",
    clipPath: "url(#clip0_578_401881)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cert-bronze"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ribbon-bronze"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9488 55.7703L18.9763 51.6954V33.2988H9.31006V54.7933C9.31006 55.6035 10.2126 56.1516 10.9488 55.7703Z",
    fill: "#00ACEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9799 55.7703L18.9524 51.6954V33.2988H28.5949V54.7933C28.6186 55.6035 27.7399 56.1516 26.9799 55.7703Z",
    fill: "#009AD5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.31006 27.7944V35.6821C9.31006 36.5161 10.7826 37.3978 11.6376 37.3978L14.4163 37.9221L16.7913 39.2804C18.1451 40.0668 19.7838 40.0668 21.1376 39.2804L23.5126 37.9221L26.2913 37.3978C27.1226 37.3978 28.6188 36.6115 28.6188 35.6821V27.7944H9.31006Z",
    fill: "#007BAA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3587 16.8565L30.0912 4.15523C29.3074 2.79693 27.8824 1.96289 26.3149 1.96289H11.6374C10.0699 1.96289 8.64492 2.79693 7.86117 4.15523L0.593672 16.8565C-0.190078 18.2148 -0.190078 19.8591 0.593672 21.2174L7.86117 33.9186C8.64492 35.2769 10.0699 36.111 11.6374 36.111H26.2912C27.8587 36.111 29.2837 35.2769 30.0674 33.9186L37.3349 21.2174C38.1187 19.8591 38.1187 18.191 37.3587 16.8565Z",
    fill: "#C4875F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7913 0.580704L4.13251 7.87262C2.77876 8.659 1.94751 10.0888 1.94751 11.6616V26.3645C1.94751 27.9373 2.77876 29.3671 4.13251 30.1535L16.7913 37.4454C18.145 38.2318 19.7838 38.2318 21.1375 37.4454L33.7963 30.1535C35.15 29.3671 35.9813 27.9373 35.9813 26.3645V11.6616C35.9813 10.0888 35.15 8.659 33.7963 7.87262L21.1375 0.580704C19.7838 -0.181849 18.145 -0.181849 16.7913 0.580704Z",
    fill: "#C4875F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4214 6.51413L30.0677 4.13115C29.2839 2.77285 27.8589 1.93881 26.2914 1.93881H23.5127L21.1377 0.58051C19.7839 -0.205873 18.1452 -0.205873 16.7914 0.58051L14.4164 1.93881H11.6377C10.0702 1.93881 8.64517 2.77285 7.86142 4.13115L6.50767 6.51413L4.13267 7.87243C2.77892 8.65881 1.94767 10.0886 1.94767 11.6614V14.4494L0.593916 16.8324C-0.189834 18.1907 -0.189834 19.835 0.593916 21.1933L1.94767 23.5763V26.3643C1.94767 27.9371 2.77892 29.3669 4.13267 30.1533L6.50767 31.5116V31.5354L31.4214 6.51413Z",
    fill: "#DB9877"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.45752 19.0247C7.45752 25.4111 12.6113 30.5822 18.9763 30.5822C25.3413 30.5822 30.495 25.4111 30.495 19.0247C30.495 12.6383 25.3413 7.46729 18.9763 7.46729C12.6113 7.46729 7.45752 12.6383 7.45752 19.0247Z",
    fill: "url(#paint0_linear_578_401881)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-19",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9764 9.68369C24.6764 9.68369 29.3314 14.3305 29.5689 19.5016C29.5689 19.3347 29.5926 19.1918 29.5926 19.025C29.5926 13.139 24.8426 8.37305 18.9764 8.37305C13.1101 8.37305 8.36011 13.139 8.36011 19.025C8.36011 19.1918 8.36011 19.3347 8.38386 19.5016C8.62136 14.3305 13.2526 9.68369 18.9764 9.68369Z",
    fill: "#9B5837"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-21",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9763 29.6767C13.1101 29.6767 8.36007 24.9108 8.36007 19.0248C8.36007 13.1388 13.1101 8.37288 18.9763 8.37288C24.8426 8.37288 29.5926 13.1388 29.5926 19.0248C29.5926 24.9108 24.8188 29.6767 18.9763 29.6767ZM18.9763 6.51416C12.0888 6.51416 6.50757 12.1142 6.50757 19.0248C6.50757 25.9354 12.0888 31.5354 18.9763 31.5354C25.8638 31.5354 31.4451 25.9354 31.4451 19.0248C31.4213 12.1142 25.8401 6.51416 18.9763 6.51416Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-23",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3563 13.2582L20.9475 16.5229C21.0188 16.642 21.1375 16.7374 21.28 16.7612L24.8663 17.2855C25.2225 17.3331 25.365 17.7859 25.1038 18.0242L22.515 20.5501C22.42 20.6455 22.3725 20.7884 22.3963 20.9314L23.0138 24.5059C23.085 24.8633 22.705 25.1255 22.3963 24.9586L19.19 23.2667C19.0713 23.1952 18.905 23.1952 18.7863 23.2667L15.58 24.9586C15.2713 25.1255 14.8913 24.8633 14.9625 24.5059L15.58 20.9314C15.6038 20.7884 15.5563 20.6455 15.4613 20.5501L12.825 18.0242C12.5638 17.762 12.7063 17.3331 13.0625 17.2855L16.6488 16.7612C16.7913 16.7374 16.91 16.642 16.9813 16.5229L18.5725 13.2582C18.7388 12.9484 19.19 12.9484 19.3563 13.2582Z",
    fill: "#DB9877"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-25",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9688 17.0468L23.5601 16.6417C23.6313 16.6179 23.6313 16.5225 23.5601 16.4987L21.9688 16.0936C21.7788 16.0459 21.6601 15.903 21.6126 15.7362L21.2088 14.1396C21.1851 14.0681 21.0901 14.0681 21.0663 14.1396L20.6626 15.7362C20.6151 15.9268 20.4726 16.0459 20.3063 16.0936L18.7151 16.4987C18.6438 16.5225 18.6438 16.6179 18.7151 16.6417L20.3063 17.0468C20.4963 17.0944 20.6151 17.2374 20.6626 17.4042L21.0663 19.0008C21.0901 19.0723 21.1851 19.0723 21.2088 19.0008L21.6126 17.4042C21.6363 17.2136 21.7788 17.0706 21.9688 17.0468Z",
    fill: "white"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_578_401881",
    x1: 18.9684,
    y1: 7.47601,
    x2: 18.9684,
    y2: 30.5764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1805B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC6D49"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_578_401881"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRibbonBronze);
export default __webpack_public_path__ + "static/media/ribbonBronze.31cc73cfdaa7077c429afe9431bd502a.svg";
export { ForwardRef as ReactComponent };